/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {CreateUserRequest} from '../models/CreateUserRequest';
import type {Error} from '../models/Error';

export interface CreateUser$Request {
    createUserRequest: CreateUserRequest;
}

export interface CreateUser$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const createUserRequest = createAction<PayloadData<void, CreateUser$Request>>('CREATE_USER__CREATE_USER__REQUEST');
export const createUserSuccess = createAction<PayloadData<number, CreateUser$Request>>('CREATE_USER__CREATE_USER__SUCCESS');
export const createUserFailure = createAction<PayloadData<Error, CreateUser$Request, true>>('CREATE_USER__CREATE_USER__FAILURE');

export const createUserActions = [
    createUserRequest,
    createUserSuccess,
    createUserFailure
] as const;

/**
 * @param {CreateUserRequest} meta.createUserRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const createUser = (meta: CreateUser$Request, config?: CreateUser$Config) => {
    return {
        CALL_API: {
            types: createUserActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/users`,
            TRANSPORT_REQUEST_BODY: meta.createUserRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

